import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import type { PropsWithChildren } from 'react';
import type React from 'react';
import styled from 'styled-components';
import { TuneInfoComponentsFactory } from './infoComponents/TunesInfoFactory';
import type { TuneControlsDisclaimerType } from '@/engine/app/interfaces';
import { FormControlLabel, Switch } from '@mui/material';
import { useBooleanTuner } from './useBooleanTuner';

interface SwitchTuneProps {
  descriptor: string;
  disclaimer?: TuneControlsDisclaimerType;
  label: string;
}

export const SwitchTune: React.FC<PropsWithChildren<SwitchTuneProps>> = (props: SwitchTuneProps) => {
  const { value, tuner } = useBooleanTuner(props.descriptor);

  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl fullWidth>
        <ControlContainer>
          <FormControlLabel
            sx={{
              width: 211,
              marginRight: '0.2em'
            }}
            control={<Switch checked={value} onChange={(event, checked): void => tuner.doTune(checked)} />}
            label={props.label}
          />
          <TuneInfoComponentsFactory disclaimer={props.disclaimer} />
        </ControlContainer>
      </FormControl>
    </Box>
  );
};

const ControlContainer = styled.div`
  padding: 0 0 0.6em 0;
  position: relative;
  margin-top: 0.6em;

  label {
    display: inline;
  }
`;
